module.exports = __webpack_public_path__ + "img/terroir-grid-2-mobile.26a83ba0.jpg";